<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      icon="BellIcon"
      class="cursor-pointer mt-1 sm:mr-6 mr-2"
      :badge="notifications.length"
    />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notifications.length }} New</h3>
        <p class="opacity-75">App Notifications</p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="ntf in notifications"
            :key="ntf._id"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
          >
            <router-link :to="ntf.href" class="routerLink">
              <div class="flex items-start">
                <feather-icon
                  :icon="ntf.icon"
                  :svgClasses="[`text-${getColorByImportance(ntf.importance)}`, 'stroke-current mr-1 h-6 w-6']"
                ></feather-icon>

                <div class="mx-2">
                  <span
                    class="font-medium block notification-title"
                    :class="[`text-${getColorByImportance(ntf.importance)}`]"
                    style="text-transform: capitalize;"
                  >{{ ntf.title }}</span>
                  <small>{{ ntf.description }}</small>
                </div>
              </div>
              <small class="mt-1 whitespace-no-wrap">{{ ntf.createdAt | moment('from', 'now') }}</small>
            </router-link>
          </li>
        </ul>
      </component>

      <div
        @click="clearNotifications"
        class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
      >
        <span>Clear Notifications</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      notifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },
  computed: {
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    getColorByImportance (importance) {
      switch (importance) {
      case 1:
        return 'success'
      case 2:
        return 'warning'
      case 3:
        return 'danger'
      default:
        return 'primary'
      }
    },
    getNotifications () {
      this.$http.get("/user/notifications?type=unread").then(res => {
        if (res.data.status && res.data.status === true) {
          this.notifications = res.data.notifications.reverse()
        }
      })
    },
    clearNotifications(){
      let markAsRead = this.notifications.map(n => n._id);
      this.$http.post('/user/notifications', {markAsRead}).then(res => {
        this.getNotifications();
      });
    }
  },
  created () {
    this.getNotifications()
    const notifier = setInterval(() => {
      this.getNotifications()
      // eventBus.$emit("notify-triggered", notifier);
    }, 10000)
    localStorage.notifier = notifier
  }
}
</script>
<style>
.routerLink {
  text-decoration: none;
  color: black;
  display: contents;
}
</style>

